import type { NextApiRequest, NextApiResponse } from 'next'
import type { GetOrderResponse } from 'ecosystem'
import { briqpayApi } from 'api'

export const briqpayPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<GetOrderResponse | { error: string }>
) => {
  // For Briqpay this is the sessionId — the FE reads it off the create response, and the
  // confirmation page recovers it from the SF order's persisted `paymentId`.
  const { orderId } = req.query as { orderId: string }

  if (!orderId) {
    res.status(400).json({ error: 'OrderId was not provided' })
    return
  }

  const { error, data: briqpaySession } = await briqpayApi.checkout.readSession(orderId)

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ briqpayResponse: briqpaySession } as GetOrderResponse)
}
